import { useParams } from 'react-router-dom';

import PaymentsTable from 'src/features/payments/components/tables/PaymentsTable';

/**
 * The payments tab of the subscription dashboard.
 *
 * PaymentsTable is shared across screens and filters by the `item_type`/`item_id` props, which a
 * route element cannot receive directly — this wrapper reads the subscription from the URL and
 * supplies them.
 */
const SubscriptionPaymentsTab = () => {
    const { subscriptionId = '' } = useParams();

    return <PaymentsTable item_type="subscription" item_id={subscriptionId} />;
};

export default SubscriptionPaymentsTab;
